// var featuredCollectionSection={init:function(){$(".js-product-slider .products-slider").each(function(e,t){var a,i,o,n,r,s=$(this).data("products-per-slide"),l=$(this).data("products-limit"),d=$(this).data("products-available");a="2"==s&&d>s&&l>s||"4"==s&&d>s&&l>s||"6"==s&&d>s&&l>s?"left":"center",d>s&&l>s?(i=!0,o=!0,n=!0):(i=!1,o=!1,n=!1),"2"==s&&d>s||"4"==s&&d>s||"6"==s&&d>s?r=0:"3"==s&&d?r=1:"5"==s&&d?r=2:"7"==s&&d&&(r=3),$(window).width()<=798&&(a="center",i=!0,o=!0,n=!0,r=1,$(this).parents(".even-num-slides").removeClass("even-num-slides")),$(this).flickity({lazyLoad:2,imagesLoaded:!0,draggable:i,prevNextButtons:o,wrapAround:n,cellAlign:a,pageDots:usePageDots,contain:!0,freeScroll:!0,arrowShape:arrowSize,initialIndex:r}),$(this).addClass("slider-initialized")})},unload:function(e){var t=e.find(".js-product-slider");t.hasClass("flickity-enabled")&&t.flickity("destroy")}},featuredPromotions={init:function(){($(window).width()>798||0==$(window).width())&&($(".feature-overlay").hover(function(){$(this).find(".feature-details").slideDown("100",function(){$(this).addClass("reveal-details")})},function(){$(this).find(".feature-details").removeClass("reveal-details"),$(this).find(".feature-details").slideUp("100")}),$(".js-featured-promotions").each(function(e,t){var a=$(this),i=$(this).data("promo-animation");a.waypoint(function(){$(this.element).find(".feature-section").addClass("animated "+i)},{offset:"80%"})}))}},slideshow={init:function(){$(".js-homepage-slideshow").each(function(e,t){var a=$(this),i={slideshowSpeed:1e3*a.data("slideshow-speed"),slideshowTextAnimation:a.data("slideshow-text-animation"),adaptiveHeight:a.data("adaptive-height")};if(!a.hasClass("flickity-enabled")){var o=1!==a.find(".gallery-cell").length;if(a.flickity({adaptiveHeight:i.adaptiveHeight,wrapAround:!0,cellAlign:"left",imagesLoaded:!0,prevNextButtons:o,draggable:o,pageDots:usePageDots,autoPlay:i.slideshowSpeed,arrowShape:arrowSize}),""!=i.slideshowTextAnimation){var n=a.data("flickity");setTimeout(function(){a.find(".gallery-cell:nth-child(1) .caption-content").addClass("animated "+i.slideshowTextAnimation)},400),a.on("select.flickity",function(){if(a.is(":visible")){var e=n.selectedIndex+1;setTimeout(function(){a.find(".caption-content").removeClass("animated "+i.slideshowTextAnimation),a.find(".gallery-cell:nth-child("+e+") .caption-content").addClass("animated "+i.slideshowTextAnimation)},400)}})}}a.find(".gallery-cell").length>1?a.addClass("multi-image"):a.addClass("single-image"),a.find(".gallery-cell").each(function(){var e=0;$(this).find(".action_button").each(function(){$button=$(this),$(this).width()>e&&(e=$(this).width())}),$(this).find(".action_button").width(e)})})},unload:function(e){e.find(".js-homepage-slideshow").flickity("destroy")}},testimonial={init:function(){$(".js-testimonial").each(function(e,t){var a=$(this),i={slideshowSpeed:1e3*a.data("slideshow-speed"),slideshowTextAnimation:a.data("slideshow-text-animation")};if($(".testimonial-image").length>0&&$(".testimonial-block").each(function(){if(0==$(this).find(".testimonial-image").length){var e=$(this).closest(".testimonial-block");$(e).addClass("set-testimonial-height")}}),!a.hasClass("flickity-enabled")){var o=1!==a.find(".gallery-cell").length;if(a.flickity({wrapAround:!0,cellAlign:"left",imagesLoaded:!0,prevNextButtons:o,draggable:o,pageDots:usePageDots,autoPlay:i.slideshowSpeed,arrowShape:arrowSize}),""!=i.slideshowTextAnimation){var n=a.data("flickity");setTimeout(function(){a.find(".gallery-cell:nth-child(1) .caption-content").addClass("animated "+i.slideshowTextAnimation)},400),a.on("select.flickity",function(){if(a.is(":visible")){var e=n.selectedIndex+1;setTimeout(function(){a.find(".caption-content").removeClass("animated "+i.slideshowTextAnimation),a.find(".gallery-cell:nth-child("+e+") .caption-content").addClass("animated "+i.slideshowTextAnimation)},400)}})}}a.find(".gallery-cell").length>1?a.addClass("multi-image"):a.addClass("single-image"),a.find(".gallery-cell").each(function(){var e=0;$(this).find(".action_button").each(function(){$button=$(this),$(this).width()>e&&(e=$(this).width())}),$(this).find(".action_button").width(e)})})},unload:function(e){e.find(".js-testimonial").flickity("destroy")}},gallery={init:function(){$(".gallery-horizontal").find(".gallery-image-wrapper").each(function(){var e,t,a=$(this),i=$(this).find("img");$("<img />").attr("src",$(i).attr("src")).on("load",function(){e=this.width,t=this.height,$(a).css("flex-basis",200*e/t),$(a).css("flex-grow",200*e/t),$(a).find("i").css("padding-bottom",t/e*100+"%")})}),$("[rel=gallery]").length&&$("[rel=gallery]").fancybox({baseClass:"gallery-section__lightbox",clickContent:"nextOrClose"})}},supports_video=function(){return!!document.createElement("video").canPlayType},videoSection={init:function(){function e(e){e.find(".caption").not(".display-mobile-text").hide(),e.find(".caption").not(".display-mobile-text").find(".action_button").hide()}($(".js-video.lazyframe").each(function(e,t){if($(t).hasClass("showPosterImage--true")){var a=$(t).closest(".video-section").attr("id");lazyframe("#"+a+" .lazyframe.showPosterImage--true",{initinview:!1})}else{a=$(t).closest(".video-section").attr("id");lazyframe("#"+a+" .lazyframe.showPosterImage--false",{initinview:!0,onLoad:function(e){$(t).find("iframe").slice(1).remove()}})}}),$(".js-video").hasClass("hide-text-on-video")&&$(".js-video").hasClass("video-autoplay--true"))&&e($(".js-video.hide-text-on-video.video-autoplay--true"));$(".video-section .lazyvideo.hide-text-on-video").on("click",function(){e($(this).parents(".js-video-section"))}),$("[data-play-video-button], video.hide-text-on-video").on("click",function(){var t=$(this).parents(".js-video-section"),a=t.find(".lazyframe"),i=t.find(".js-video");if(i.data("mp4")||i.data("ogv"))t.find(".js-video.hide-text-on-video").length&&e(t);else{var o=document.createElement("iframe");iframeSrc=a.data("src"),cleanIframeSrc=iframeSrc.substring(0,iframeSrc.indexOf("?"))+"?&autoplay=1",o.src=cleanIframeSrc,o.setAttribute("allowfullscreen",!0),o.setAttribute("frameborder",0),a.append(o),t.find(".js-video.hide-text-on-video").length&&e(t)}})},unload:function(e){e.find("[data-play-video]").off("click"),e.find("video.hide-text-on-video").off("click")}},cart={init:function(){$("#cart_form .tos_agree").length&&$("body").on("click","#cart_form input[type='submit']",function(){if(!$(this).parents("form").find(".tos_agree").is(":checked")){var e='<p class="warning animated bounceIn">'+Shopify.translation.agree_to_terms_warning+"</p>";return 0==$("p.warning").length&&$(this).before(e),!1}$(this).submit()})}};selectCallback=function(e,t){var a=$(".product-"+t.product.id),i=$(".notify-form-"+t.product.id),o=$(".product_form, .shopify-product-form",a),n=o.data("variant-inventory"),r=$(".notify_form__inputs"),s=Shopify.translation.notify_email,l=Shopify.translation.notify_email_send,d=r.data("url");if(e)var c=Shopify.translation.notify_message_first+e.title+Shopify.translation.notify_message_last+d;if(r.hasClass("customer--true"))var p='<input type="hidden" class="notify_email" name="contact[email]" id="contact[email]" value="" />';else p='<input required type="email" class="notify_email" name="contact[email]" id="contact[email]" placeholder="'+s+'" value="" />';var m=p+'<input type="hidden" name="challenge" value="false" /><input type="hidden" name="contact[body]" class="notify_form_message" data-body="'+c+'" value="'+c+'" /><input class="action_button" type="submit" value="'+l+'" style="margin-bottom:0px" />';e&&e.featured_image&&a.is(":visible")&&$(".js-product-gallery, .js-gallery-modal",a).each(function(){var t=$(this),a=Flickity.data(this);if(t.is(":visible")&&null!=a){var i=$('[data-image-id="'+e.featured_image.id+'"]').data("index");a.select(i,!1,!0)}});if(e)if(n&&n.forEach(function(t){t.id===e.id&&(e.inventory_quantity=t.inventory_quantity,e.inventory_management=t.inventory_management,e.inventory_policy=t.inventory_policy)}),$(".sku span",a).text(e.sku),"swatches"==Shopify.theme_settings.product_form_style)for(var f=0,u=e.options.length;f<u;f++){var y=o.find('.swatch[data-option-index="'+escape(f)+'"] :radio[value="'+e.options[f].replace(/\"/g,'\\"')+'"]');y.length&&(y.get(0).checked=!0)}else $(".notify_form_message",a).attr("value",$(".notify_form_message",a).data("body")+" - "+e.title);if(e&&1==e.available){if(e.price<e.compare_at_price?($(".was_price",a).html('<span class="money">'+Shopify.formatMoney(e.compare_at_price,$("body").data("money-format"))+"</span>"),$(".savings",a).html(Shopify.translation.savings_text+" "+parseInt(100*(e.compare_at_price-e.price)/e.compare_at_price)+'% (<span class="money">'+Shopify.formatMoney(e.compare_at_price-e.price,$("body").data("money-format"))+"</span>)"),$(".current_price",a).parent().addClass("sale")):($(".was_price",a).html(""),$(".savings",a).html(""),$(".current_price",a).parent().removeClass("sale")),e.inventory_management&&e.inventory_quantity>0){if(Shopify.theme_settings.display_inventory_left){1==e.inventory_quantity?items_left_text=Shopify.translation.one_item_left:items_left_text=Shopify.translation.items_left_text;var h=parseInt(Shopify.theme_settings.inventory_threshold);e.inventory_quantity<=h?$(".items_left",a).html(e.inventory_quantity+" "+items_left_text):$(".items_left",a).html("")}Shopify.theme_settings.limit_quantity&&"deny"==e.inventory_policy&&$(".quantity",a).attr("max",e.inventory_quantity)}else $(".items_left",a).text(""),$(".quantity",a).removeAttr("max");$(".sold_out",a).text(""),e.price>0?$(".current_price",a).removeClass("sold_out").html('<span class="money">'+Shopify.formatMoney(e.price,$("body").data("money-format"))+"</span>"):$(".current_price",a).removeClass("sold_out").html(Shopify.theme_settings.free_text),$(".add_to_cart",a).removeClass("disabled").removeAttr("disabled").find("span").text($(".add_to_cart",a).data("label")),$(".shopify-payment-button",a).removeClass("disabled"),$(".purchase-details__buttons",a).removeClass("product-is-unavailable"),$(".modal_price",a).removeClass("variant-unavailable"),i.hide(),r.empty()}else{var g=e?Shopify.theme_settings.sold_out_text:Shopify.translation.unavailable_text;e?(e.price>0?$(".current_price",a).html('<span class="money">'+Shopify.formatMoney(e.price,$("body").data("money-format"))+"</span>"):$(".current_price",a).html(Shopify.theme_settings.free_text),Shopify.theme_settings.display_sold_out_price&&$(".current_price",a).parents(".price__container--display-price-true").addClass("has-margin-right"),$(".modal_price",a).removeClass("variant-unavailable")):($(".modal_price",a).addClass("variant-unavailable"),$(".current_price",a).html(""),$(".was_price",a).html(""),$(".savings",a).html(""),$(".current_price",a).parents(".price__container--display-price-true").removeClass("has-margin-right")),Shopify.theme_settings.display_sold_out_price||($(".current_price",a).html(""),$(".was_price",a).html(""),$(".savings",a).html("")),$(".items_left",a).text(""),$(".quantity",a).removeAttr("max"),$(".sold_out",a).text(g),$(".purchase-details__buttons",a).addClass("product-is-unavailable"),$(".add_to_cart",a).addClass("disabled").attr("disabled","disabled").find("span").text(g),$(".shopify-payment-button").addClass("disabled"),i.hide(),r.empty(),e&&!e.available&&(i.fadeIn(),r.empty(),r.append(m))}Shopify.theme_settings.show_multiple_currencies&&convertCurrencies()};var productPage={init:function(){var e=!0,t=!0,a=$(".js-product-gallery").data("autoplay");setTimeout(function(){imageFunctions.linkGalleryAndCarousel($(".js-product-page-gallery .js-product-gallery"),$(".js-product-page-gallery .product_gallery_nav"))},1e3),$(".js-full-width-product-images").length&&imageFunctions.fullWidth(".product-template .product .description img",".js-full-width-product-images"),$(".js-product-gallery").hasClass("single-image")&&(e=!1,t=!1),$(".product_section .description").find("iframe").wrap('<div class="lazyframe" data-ratio="16:9"></div>'),is_touch_device()&&$(".js-product-gallery").hasClass("popup-enabled--false")?(imageFunctions.zoom(".js-product-gallery"),e=!1):imageFunctions.zoom(".js-product-gallery",!1),$(".js-product-gallery").flickity({adaptiveHeight:!0,wrapAround:"true",cellAlign:"left",draggable:e,contain:!0,imagesLoaded:!0,lazyLoad:2,pageDots:!1,prevNextButtons:t,autoPlay:!!a&&6e3,dragThreshold:10,arrowShape:arrowSize});var i=!0,o=!1,n=!1;$(".product_gallery_nav .gallery-cell").length>=7&&(i=!1,o=!0,"left",n=!0),$(".product-template .product_gallery_nav.product_gallery_nav--bottom-slider").flickity({asNavFor:".product_gallery",adaptiveHeight:!1,wrapAround:n,cellAlign:"center",draggable:!0,groupCells:i,prevNextButtons:o,pageDots:!1,lazyLoad:2,dragThreshold:10,arrowShape:arrowSize}),"?contact_posted=true"===window.location.search&&($(".notify_form .contact-form").hide(),$(".notify_form .contact-form").prev(".message").html(Shopify.translation.notify_success_text)),$(".notify_form .contact-form").each(function(){var e=$(this);e.on("submit",function(t){"true"!==$('input[name="challenge"]',e).val()&&($.ajax({type:e.attr("method"),url:e.attr("action"),data:e.serialize(),success:function(t){e.fadeOut("slow",function(){e.prev(".message").html(Shopify.translation.notify_success_text)})},error:function(t){$('input[name="challenge"]',e).val("true"),e.submit()}}),t.preventDefault())})}),"swatches"==Shopify.theme_settings.product_form_style&&$("body").on("change",".swatch :radio",function(){var e=$(this).closest(".swatch").attr("data-option-index"),t=$(this).val(),a=$(this).closest(".product_form form");if(a.siblings(".notify_form").length)var i=a.siblings(".notify_form");else i=$(".js-notify-form");var o=a.find(".swatch_options input:checked").eq(0).val(),n=a.find(".swatch_options input:checked").eq(1).val()||"",r=a.find(".swatch_options input:checked").eq(2).val()||"";if(o&&n&&r)var s=o+" / "+n+" / "+r;else if(o&&n)s=o+" / "+n;else s=o;i.find(".notify_form_message").attr("value",i.find(".notify_form_message").data("body")+" - "+s),$(this).closest("form").find(".single-option-selector").eq(e).val(t).trigger("change")}),$(".js-product-gallery a").fancybox({baseClass:"product-section__lightbox",clickContent:!1,afterShow:function(e,t){e.$trigger.first().parents(".js-product-gallery").data("zoom")&&$(".fancybox-image").wrap('<span class="zoom-wrap" style="display:inline-block"></span>').css("display","block").parent().zoom({touch:!1,magnify:1})},afterClose:function(e,t){const a=e.$trigger.first().parents(".js-product-gallery");a.hide(),setTimeout(function(){a.fadeIn(100)},1)}}),$(".js-product_section .product_form_options").each(function(){$(this).find(".selector-wrapper select").length!=$(this).data("options-size")&&new Shopify.OptionSelectors($(this).data("select-id"),{product:$(this).data("product"),onVariantSelected:selectCallback,enableHistoryState:$(this).data("enable-state")})}),$(".product-recommendations-container").length&&productPage.loadProductRecommendations()},loadProductRecommendations:function(){var e=$(".meta-related-recommended-collection"),t=$(".product-recommendations"),a=t.data("productId"),i=t.data("limit"),o=t.data("enabled"),n=e.data("enabled"),r=$("[data-product-recommendations-container]"),s=$(".js-recommended-products-slider");if(e.length){if(!n)return void r.empty();r.html(e.html()),s.length&&this.recommendedProductsSlider(),$("[data-product-recommendations-container] .js-product_section .product_form_options").each(function(){0===$(this).find("select").length&&new Shopify.OptionSelectors($(this).data("select-id"),{product:$(this).data("product"),onVariantSelected:selectCallback,enableHistoryState:$(this).data("enable-state")})}),Shopify.PaymentButton&&Shopify.PaymentButton.init(),$(".recommended-products-section").empty()}else if(t.length){if(!o)return void r.empty();$.ajax({type:"GET",url:"/recommendations/products?section_id=product-recommendations&limit="+i+"&product_id="+a,success:function(e){var t=$(e).find(".product-recommendations").html();r.empty(),r.html(t),s.length&&productPage.recommendedProductsSlider(),$("[data-product-recommendations-container] .js-product_section .product_form_options").each(function(){new Shopify.OptionSelectors($(this).data("select-id"),{product:$(this).data("product"),onVariantSelected:selectCallback,enableHistoryState:$(this).data("enable-state")})}),Shopify.PaymentButton&&Shopify.PaymentButton.init(),0===$("[data-recommended-product-count]").data()&&$("[data-product-recommendations-container]").hide()}})}else r.hide()},productSwatches:function(){if("swatches"==Shopify.theme_settings.product_form_style){if($(".js-product_section").length){var e=$(".js-product_section").find(".product_form");e.addClass("is-visible"),e.each(function(){var e=$(this).data("product"),t=".product-"+$(this).data("product-id")+" .js-product_section";$(this).find(".swatch_options .swatch").length>1&&Shopify.linkOptionSelectors(e,t)})}$(".js-product_section").length>1&&$("body").on("click",".swatch-element",function(){var e=$(this).data("value").toString();$(this).siblings('input[value="'+e.replace(/\"/g,'\\"')+'"]').prop("checked",!0).trigger("change");var t=$(this).parents(".product_form").data("product"),a=".product-"+$(this).parents(".product_form").data("product-id")+" .js-product_section";$(this).parents(".product_form").find(".swatch_options .swatch").length>1&&Shopify.linkOptionSelectors(t,a)})}},recommendedProductsSlider:function(){$(".js-recommended-products-slider .products-slider").each(function(e,t){var a,i,o,n,r,s=$(this).data("products-per-slide"),l=$(this).data("products-limit"),d=$(this).data("products-available");a="2"==s&&d>s&&l>s||"4"==s&&d>s&&l>s||"6"==s&&d>s&&l>s?"left":"center",d>s&&l>s?(i=!0,o=!0,n=!0):(i=!1,o=!1,n=!1),"2"==s&&d>s||"4"==s&&d>s||"6"==s&&d>s?r=0:"3"==s&&d?r=1:"5"==s&&d?r=2:"7"==s&&d&&(r=3),$(window).width()<=798&&(a="center",i=!0,o=!0,n=!0,r=1,$(this).parents(".even-num-slides").removeClass("even-num-slides")),$(this).flickity({lazyLoad:2,imagesLoaded:!0,draggable:i,cellAlign:a,prevNextButtons:o,wrapAround:n,pageDots:usePageDots,contain:!0,freeScroll:!0,arrowShape:arrowSize,initialIndex:r})})},initializeQuantityBox:function(){$("body").on("click",".js-change-quantity",function(){var e=$(this),t=$(this).siblings("input"),a=parseInt(t.val()),i=1e29,o=t.attr("min")||0;return null!=t.attr("max")&&(i=t.attr("max")),isNaN(a)||a<o?(t.val(o),!1):a>i?(t.val(i),!1):("plus"==e.data("func")?a<i&&t.val(a+1):(a>o&&t.val(a-1),e.parents(".cart_item").length&&a-1==0&&e.closest(".cart_item").addClass("animated fadeOutUp")),void t.trigger("change"))})},unload:function(e){e.find(".products-slider").flickity("destroy"),$("body").off("click",".js-change-quantity")}},header={init:function(){var e=function(){$("body").removeClass("is-active").removeClass("blocked-scroll"),$(".dropdown_link").toggleClass("active_link"),$(".cart_container").removeClass("active_link")};($(".dropdown_link--vertical").length&&($(".dropdown_link--vertical, .vertical-menu_submenu").on("mouseover",function(e){$(this).parents(".main_nav").find('[data-dropdown="'+$(this).data("dropdown-rel")+'"]'),$(this).attr("data-click-count");$(".active_link").removeClass("active_link"),$(this).hasClass("active_link")||($(this).children("a").addClass("active_link"),$(".is-absolute").parent().removeClass("feature_image"))}),is_touch_device()&&$(".vertical-menu .sublink a, .vertical-menu_submenu .sublink a").on("touchstart click",function(e){e.stopPropagation();var t=$(this);function a(t){var a=$(t).parents(".main_nav").find('[data-dropdown="'+$(this).data("dropdown-rel")+'"]'),i=$(t).next(".vertical-menu_submenu"),o=$(t).attr("data-click-count");if($(".dropdown_link--vertical").not(t).attr("data-click-count",0),$(".dropdown_link--vertical").attr("data-no-instant",!0),$(".dropdown_container").hide(),a.show(),$(".vertical-menu_submenu").removeClass("is-visible"),i.addClass("is-visible"),"touchstart"==e.type&&(o++,$(t).attr("data-click-count",o),o<2))return e.preventDefault(),e.stopPropagation(),!1}"touchstart"==e.type?(clicked=!0,$(this).attr("data-click-count")<1&&(a(t),e.preventDefault())):"click"!=e.type||clicked?clicked=!1:$(this).attr("data-click-count")<1&&(a(t),e.preventDefault())})),$(".promo_banner").length)&&("dismiss"!=Cookies.get("promo_banner")&&($("body").addClass("promo_banner-show"),$(".promo_banner").on("click",".promo_banner-close",function(){$("body").removeClass("promo_banner-show"),Cookies.set("promo_banner","dismiss",{expires:30})})));if($(".vertical-menu_submenu, .vertical-menu_sub-submenu").each(function(){$(this).is(":off-right")&&$(this).addClass("vertical-menu--align-right")}),$("html").on("click",function(t){!$(t.target).closest(".cart_container").length&&$(".cart_content").is(":visible")&&e(),!$(t.target).closest(".dropdown_container").length&&$(".dropdown").is(":visible")&&($("body").removeClass("is-active"),$(".dropdown_link").removeClass("active_link"),$(".dropdown_container").hide(),$(".mobile_nav").find("div").removeClass("open"))}),$(window).width()>798){if($(".header").hasClass("header-fixed--true")){if($("body").on("click",'.banner a[href^="#"]',function(e){e.preventDefault();var t=$(this).attr("href"),a=$(".main_nav_wrapper.sticky_nav").outerHeight();$("html, body").animate({scrollTop:$(t).offset().top-a},2e3)}),!$(".main_nav_wrapper").hasClass("sticky_nav"))new Headhesive(".main_nav_wrapper",{offset:700,throttle:300,classes:{clone:"sticky_nav",stick:"sticky_nav--stick",unstick:"sticky_nav--unstick"},onInit:function(){if($(".sticky_nav .secondary_logo").css("display","none"),$(".sticky_nav .primary_logo").css("display","block"),$(".sticky_nav .icon-search").css("display","block"),$(".sticky_nav .search_container").css("display","none"),$(".sticky_nav .nav:last").prepend($(".header .cart_container").clone()),"inline"==Shopify.theme_settings.menu_position)$(".sticky_nav").height();else $(".sticky_nav .nav").height()},onStick:function(){$(".sticky_nav .mini_cart").css("height",$(".sticky_nav .main_nav").height()),$(".sticky_nav .cart_content").css("top",$(".sticky_nav .main_nav").height())},onUnstick:function(){$(".cart_container").removeClass("active_link")}})}else $(".header-fixed--true").removeClass("header-fixed--true"),$(".main_nav_wrapper").length>1&&$(".main_nav_wrapper").first().remove();$("img.primary_logo:visible")?$(".logo img",$(".feature_image .header")).attr("src",$(".logo img").data("src-home")):$(".logo img").attr("src",$(".logo img").data("src"))}else $("#header").hasClass("mobile_nav-fixed--true")?($("body").addClass("mobile_nav-fixed--true"),$("body").on("click",'.banner a[href^="#"]',function(e){e.preventDefault();var t=$(this).attr("href"),a=$("#header").outerHeight();$("html, body").animate({scrollTop:$(t).offset().top-a},2e3)})):$("body").addClass("mobile_nav-fixed--false");$("#header .cart_content").length<1&&$("#header .cart_container").append($(".header .cart_content").clone()),is_touch_device()&&$(window).width()<=798||$(window).width()<=798?($(".dropdown_link").attr("data-no-instant",!0),$("body").on("click",".dropdown_link",function(e){if($(".nav a").removeClass("active_link"),$("#header").is(":visible")){var t=$(this).parents("#header").find('[data-dropdown="'+$(this).data("dropdown-rel")+'"]');$(this).hasClass("mini_cart")||$(".cart_container").removeClass("active_link")}else{if($(this).hasClass("icon-search"))return window.location=$(this).attr("href"),!1;t=$(this).parents(".main_nav").find('[data-dropdown="'+$(this).data("dropdown-rel")+'"]')}if(t.is(":visible")||void 0===t.attr("class")?(t.hide(),$("body").removeClass("is-active")):($(".dropdown_container").hide(),$(this).hasClass("cart_container")||$(".is-absolute").parent().removeClass("feature_image"),t.show(),$("body").addClass("is-active"),$(".mobile_nav").find("div").removeClass("open")),t.is(":visible"))return e.stopPropagation(),!1}),$("body").on("click",".mobile_nav",function(){$(this).find("div").toggleClass("open")}),"redirect_cart"!=Shopify.theme_settings.cart_action&&$(".mini_cart").on("click",function(t){var a=$(this).parent();a.hasClass("active_link")?(e(),$("body").removeClass("blocked-scroll")):(!function(e){$("body").addClass("blocked-scroll"),$(".mobile_nav div").removeClass("open"),$(".dropdown_link").removeClass("active_link"),e.addClass("active_link")}(a),$("body").addClass("blocked-scroll")),touch_device&&t.preventDefault()}),$(".cart_content__continue-shopping").on("click",function(t){e()})):($(".nav a, .logo a").not(".cart_content a").on("mouseenter",function(){$(this).hasClass("active_link")||0!=$(".dropdown_link--vertical").length||($(".dropdown_container").hide(),$(".active_link").removeClass("active_link"),$(".is-absolute").parent().addClass("feature_image"))}),$(".main_nav, .top_bar, .cart_container").on("mouseleave",function(){$(window).width()>798&&$(".dropdown_container").hide(),$(".active_link").removeClass("active_link"),$(".is-absolute").parent().addClass("feature_image")}),$(".dropdown_link, .dropdown_link--vertical").attr("data-click-count",0),$(".dropdown_link").on("mouseover touchstart",function(e){$(window).width()>798&&$(".dropdown_container").hide();var t=$(this).parents(".main_nav").find('[data-dropdown="'+$(this).data("dropdown-rel")+'"]'),a=$(this).attr("data-click-count");if($(".active_link").removeClass("active_link"),$(this).hasClass("active_link")||(t.show(),$(this).hasClass("mini_cart")?$(this).parent(".cart_container").addClass("active_link"):($(window).width()>798&&$(this).addClass("active_link"),$(".is-absolute").parent().removeClass("feature_image"))),is_touch_device()&&($(".dropdown_link").not(this).attr("data-click-count",0),$(".dropdown_link").attr("data-no-instant",!0),"touchstart"==e.type&&(a++,$(this).attr("data-click-count",a),a<2)))return e.preventDefault(),e.stopPropagation(),!1}))},removeDataAttributes:function(e){if($(e).length){var t,a=$(e),i=[],o=a.get(0).attributes,n=o.length;for(t=0;t<n;t++)"data-"===o[t].name.substring(0,5)&&i.push(o[t].name);$.each(i,function(e,t){a.removeAttr(t)})}},loadMegaMenu:function(){$(".sticky_nav .mega-menu").remove(),$(".header .mega-menu").remove(),$(".mega-menu-container .mega-menu").clone().appendTo(".sticky_nav .main_nav"),header.removeDataAttributes(".sticky_nav .mega-menu.dropdown_container .dropdown_column"),$(".mega-menu-container .mega-menu").each(function(e){var t=$(this).data("dropdown");$('[data-dropdown-rel="'+t+'"]').find("span").remove(),$('[data-dropdown-rel="'+t+'"]').not(".icon-search").append(' <span class="icon-down-arrow"></span>').addClass("mega-menu-parent").addClass("dropdown_link").removeClass("top_link"),$('[data-dropdown="'+t+'"]').each(function(e){$(this).hasClass("mega-menu")||$(this).remove()}),$(this).clone().appendTo(".header .main_nav")}),$(".dropdown_link--vertical").length&&($(".dropdown_link--vertical.mega-menu-parent + .vertical-menu_submenu").remove(),$(".dropdown_link--vertical:not(.mega-menu-parent)").each(function(e){var t=$(this).data("dropdown-rel");$('[data-dropdown="'+t+'"]').remove()})),$(".mega-menu-parent").on("mouseenter",function(){$(this).hasClass("active_link")||($(".dropdown_container").hide(),$(this).parents(".main_nav").find('[data-dropdown="'+$(this).data("dropdown-rel")+'"]').toggle(),$(this).addClass("active_link"),$(".is-absolute").parent().removeClass("feature_image"))}),header.removeDataAttributes(".header .mega-menu.dropdown_container .dropdown_column"),(is_touch_device()||$(window).width()<=798)&&$(".dropdown_link").attr("data-no-instant",!0),header.loadMobileMegaMenu()},loadMobileMegaMenu:function(){$(".mega-menu-container .mobile-mega-menu").each(function(e){$('[data-mobile-dropdown-rel="'+$(this).data("mobile-dropdown")+'"]').find("span").remove(),$('[data-mobile-dropdown-rel="'+$(this).data("mobile-dropdown")+'"] > a').append(' <span class="right icon-down-arrow"></span>').attr("data-no-instant","true"),$('[data-mobile-dropdown-rel="'+$(this).data("mobile-dropdown")+'"]').addClass("mobile-mega-menu-parent sublink"),$('[data-mobile-dropdown-rel="'+$(this).data("mobile-dropdown")+'"]').append(this),$('[data-mobile-dropdown-rel="'+$(this).data("mobile-dropdown")+'"] > ul').each(function(e){$(this).hasClass("mobile-mega-menu")||$(this).remove()})})},unloadMegaMenu:function(){$(".header .mega-menu").remove(),$(".mega-menu-container .mega-menu").each(function(e){$(this).data("dropdown");$('.mega-menu-parent[data-dropdown-rel="'+$(this).data("dropdown")+'"]').find(".icon-down-arrow").remove()})},unload:function(){$("body").off("click",".mobile_nav"),$("body").off("click",".dropdown_link"),$("html").off("click"),$(".mini_cart").off("click"),$(".cart_content__continue-shopping").off("click"),$("body").off("click",'.banner a[href^="#"]'),$(".main_nav_wrapper.sticky_nav").remove()}},social={twitter:function(){$(".twitter-timeline").length&&(window.twttr?window.twttr.ready(function(e){e.widgets.load(document.getElementById("twitter-timeline"))}):window.twttr=function(e,t,a){var i,o,n=e.getElementsByTagName(t)[0];if(!e.getElementById(a))return(o=e.createElement(t)).id=a,o.src="https://platform.twitter.com/widgets.js",n.parentNode.insertBefore(o,n),window.twttr||(i={_e:[],ready:function(e){i._e.push(e)}})}(document,"script","twitter-wjs"))},unload:function(){}},instagram={loadContent:function(e){if(e.clientID){var t="https://api.instagram.com/v1/users/self/media/recent/?access_token="+e.clientID;$.ajax({type:"GET",url:t,dataType:"jsonp",success:function(t){if(200===t.meta.code&&t.data.length){t=t.data;var a=0;e.el.empty();for(var i=0;i<t.length;i++){var o,n=t[i],r=n.images.low_resolution.url;if(!n.images.low_resolution.url.indexOf("null")>-1&&(o='<div class="il-photo__img instagram__bg" style="background-image:url('+r+')" data-filter="'+n.filter+'" /></div>',o='<a href="'+n.link+'" target="_blank" class="instagram__link">'+o+"</a>"),n.videos&&(o='<div class="instagram__video instagram__bg" style="background-image:url('+r+')" data-filter="'+n.filter+'" /></div>',o='<a href="'+n.link+'" target="_blank" class="instagram__link instagram__video-link">'+o+"</a>"),o&&(o='<div class="'+e.column+' columns instagram__item small-down--one-whole">'+o+"</div>"),""!==o&&(e.el.append(o),a++),a==e.limit)break}}},error:function(){}})}}};$(".social-feeds-wrap").each(function(e,t){social.twitter();var a=$(this).find(".js-instafeed");instagram.loadContent({el:a,clientID:a.data("client-id"),limit:a.data("count"),column:a.data("column")})});var mapFunction={init:function(){if($(".lazymap").length>0&&lazyframe(".lazymap"),$(".maps").hasClass("js-api-map")){var e=[];$(".map").each(function(t,a){e.push(this),e[t].sectionid=$(this).data("id"),e[t].address=$(this).data("address"),e[t].directions=$(this).data("directions-address"),e[t].zoom=$(this).data("zoom"),e[t].mapstyle=$(this).data("style"),e[t].showpin=$(this).data("pin"),e[t].apikey=$(this).data("api-key")}),$.each(e,function(t,a){$.ajaxSetup({cache:!0}),$.getScript("https://maps.googleapis.com/maps/api/js?key="+e[t].apikey).then(function(){mapFunction.findLocation(e[t]),$.ajaxSetup({cache:!1})})})}},findLocation:function(e){var t,a;(new google.maps.Geocoder).geocode({address:e.address},function(i,o){o==google.maps.GeocoderStatus.OK?(t=i[0].geometry.location.lat(),a=i[0].geometry.location.lng(),mapFunction.initMap(t,a,e)):console.log("Error:"+o)})},initMap:function(e,t,a){var i={lat:e,lng:t},o=[];o="aubergine"==a.mapstyle?[{elementType:"geometry",stylers:[{color:"#1d2c4d"}]},{elementType:"labels.text.fill",stylers:[{color:"#8ec3b9"}]},{elementType:"labels.text.stroke",stylers:[{color:"#1a3646"}]},{featureType:"administrative.country",elementType:"geometry.stroke",stylers:[{color:"#4b6878"}]},{featureType:"administrative.land_parcel",elementType:"labels.text.fill",stylers:[{color:"#64779e"}]},{featureType:"administrative.province",elementType:"geometry.stroke",stylers:[{color:"#4b6878"}]},{featureType:"landscape.man_made",elementType:"geometry.stroke",stylers:[{color:"#334e87"}]},{featureType:"landscape.natural",elementType:"geometry",stylers:[{color:"#023e58"}]},{featureType:"poi",elementType:"geometry",stylers:[{color:"#283d6a"}]},{featureType:"poi",elementType:"labels.text.fill",stylers:[{color:"#6f9ba5"}]},{featureType:"poi",elementType:"labels.text.stroke",stylers:[{color:"#1d2c4d"}]},{featureType:"poi.park",elementType:"geometry.fill",stylers:[{color:"#023e58"}]},{featureType:"poi.park",elementType:"labels.text.fill",stylers:[{color:"#3C7680"}]},{featureType:"road",elementType:"geometry",stylers:[{color:"#304a7d"}]},{featureType:"road",elementType:"labels.text.fill",stylers:[{color:"#98a5be"}]},{featureType:"road",elementType:"labels.text.stroke",stylers:[{color:"#1d2c4d"}]},{featureType:"road.highway",elementType:"geometry",stylers:[{color:"#2c6675"}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{color:"#255763"}]},{featureType:"road.highway",elementType:"labels.text.fill",stylers:[{color:"#b0d5ce"}]},{featureType:"road.highway",elementType:"labels.text.stroke",stylers:[{color:"#023e58"}]},{featureType:"transit",elementType:"labels.text.fill",stylers:[{color:"#98a5be"}]},{featureType:"transit",elementType:"labels.text.stroke",stylers:[{color:"#1d2c4d"}]},{featureType:"transit.line",elementType:"geometry.fill",stylers:[{color:"#283d6a"}]},{featureType:"transit.station",elementType:"geometry",stylers:[{color:"#3a4762"}]},{featureType:"water",elementType:"geometry",stylers:[{color:"#0e1626"}]},{featureType:"water",elementType:"labels.text.fill",stylers:[{color:"#4e6d70"}]}]:"retro"==a.mapstyle?[{elementType:"geometry",stylers:[{color:"#ebe3cd"}]},{elementType:"labels.text.fill",stylers:[{color:"#523735"}]},{elementType:"labels.text.stroke",stylers:[{color:"#f5f1e6"}]},{featureType:"administrative",elementType:"geometry.stroke",stylers:[{color:"#c9b2a6"}]},{featureType:"administrative.land_parcel",elementType:"geometry.stroke",stylers:[{color:"#dcd2be"}]},{featureType:"administrative.land_parcel",elementType:"labels.text.fill",stylers:[{color:"#ae9e90"}]},{featureType:"landscape.natural",elementType:"geometry",stylers:[{color:"#dfd2ae"}]},{featureType:"poi",elementType:"geometry",stylers:[{color:"#dfd2ae"}]},{featureType:"poi",elementType:"labels.text.fill",stylers:[{color:"#93817c"}]},{featureType:"poi.park",elementType:"geometry.fill",stylers:[{color:"#a5b076"}]},{featureType:"poi.park",elementType:"labels.text.fill",stylers:[{color:"#447530"}]},{featureType:"road",elementType:"geometry",stylers:[{color:"#f5f1e6"}]},{featureType:"road.arterial",elementType:"geometry",stylers:[{color:"#fdfcf8"}]},{featureType:"road.highway",elementType:"geometry",stylers:[{color:"#f8c967"}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{color:"#e9bc62"}]},{featureType:"road.highway.controlled_access",elementType:"geometry",stylers:[{color:"#e98d58"}]},{featureType:"road.highway.controlled_access",elementType:"geometry.stroke",stylers:[{color:"#db8555"}]},{featureType:"road.local",elementType:"labels.text.fill",stylers:[{color:"#806b63"}]},{featureType:"transit.line",elementType:"geometry",stylers:[{color:"#dfd2ae"}]},{featureType:"transit.line",elementType:"labels.text.fill",stylers:[{color:"#8f7d77"}]},{featureType:"transit.line",elementType:"labels.text.stroke",stylers:[{color:"#ebe3cd"}]},{featureType:"transit.station",elementType:"geometry",stylers:[{color:"#dfd2ae"}]},{featureType:"water",elementType:"geometry.fill",stylers:[{color:"#b9d3c2"}]},{featureType:"water",elementType:"labels.text.fill",stylers:[{color:"#92998d"}]}]:"silver"==a.mapstyle?[{elementType:"geometry",stylers:[{color:"#f5f5f5"}]},{elementType:"labels.icon",stylers:[{visibility:"off"}]},{elementType:"labels.text.fill",stylers:[{color:"#616161"}]},{elementType:"labels.text.stroke",stylers:[{color:"#f5f5f5"}]},{featureType:"administrative.land_parcel",elementType:"labels.text.fill",stylers:[{color:"#bdbdbd"}]},{featureType:"poi",elementType:"geometry",stylers:[{color:"#eeeeee"}]},{featureType:"poi",elementType:"labels.text.fill",stylers:[{color:"#757575"}]},{featureType:"poi.park",elementType:"geometry",stylers:[{color:"#e5e5e5"}]},{featureType:"poi.park",elementType:"labels.text.fill",stylers:[{color:"#9e9e9e"}]},{featureType:"road",elementType:"geometry",stylers:[{color:"#ffffff"}]},{featureType:"road.arterial",elementType:"labels.text.fill",stylers:[{color:"#757575"}]},{featureType:"road.highway",elementType:"geometry",stylers:[{color:"#dadada"}]},{featureType:"road.highway",elementType:"labels.text.fill",stylers:[{color:"#616161"}]},{featureType:"road.local",elementType:"labels.text.fill",stylers:[{color:"#9e9e9e"}]},{featureType:"transit.line",elementType:"geometry",stylers:[{color:"#e5e5e5"}]},{featureType:"transit.station",elementType:"geometry",stylers:[{color:"#eeeeee"}]},{featureType:"water",elementType:"geometry",stylers:[{color:"#c9c9c9"}]},{featureType:"water",elementType:"labels.text.fill",stylers:[{color:"#9e9e9e"}]}]:"night"==a.mapstyle?[{elementType:"geometry",stylers:[{color:"#242f3e"}]},{elementType:"labels.text.fill",stylers:[{color:"#746855"}]},{elementType:"labels.text.stroke",stylers:[{color:"#242f3e"}]},{featureType:"administrative.locality",elementType:"labels.text.fill",stylers:[{color:"#d59563"}]},{featureType:"poi",elementType:"labels.text.fill",stylers:[{color:"#d59563"}]},{featureType:"poi.park",elementType:"geometry",stylers:[{color:"#263c3f"}]},{featureType:"poi.park",elementType:"labels.text.fill",stylers:[{color:"#6b9a76"}]},{featureType:"road",elementType:"geometry",stylers:[{color:"#38414e"}]},{featureType:"road",elementType:"geometry.stroke",stylers:[{color:"#212a37"}]},{featureType:"road",elementType:"labels.text.fill",stylers:[{color:"#9ca5b3"}]},{featureType:"road.highway",elementType:"geometry",stylers:[{color:"#746855"}]},{featureType:"road.highway",elementType:"geometry.stroke",stylers:[{color:"#1f2835"}]},{featureType:"road.highway",elementType:"labels.text.fill",stylers:[{color:"#f3d19c"}]},{featureType:"transit",elementType:"geometry",stylers:[{color:"#2f3948"}]},{featureType:"transit.station",elementType:"labels.text.fill",stylers:[{color:"#d59563"}]},{featureType:"water",elementType:"geometry",stylers:[{color:"#17263c"}]},{featureType:"water",elementType:"labels.text.fill",stylers:[{color:"#515c6d"}]},{featureType:"water",elementType:"labels.text.stroke",stylers:[{color:"#17263c"}]}]:[],$(".js-map-link").attr("href","https://www.google.com/maps/place/"+a.directions+"/@"+e+","+t);var n={zoom:a.zoom,center:i,styles:o,disableDefaultUI:!1},r=new google.maps.Map(document.getElementById(a.sectionid),n);if(1==a.showpin)new google.maps.Marker({position:i,map:r})}},faqAccordion={init:function(){var t=0,a=$(".faqAccordion > dt > button");$(".faqAccordion > dd").attr("aria-hidden",!0),a.attr("aria-expanded",!1),a.on("click activate",function(){if(t)return!1;t=1;var e="false"===$(this).attr("aria-expanded");return $(this).attr("aria-expanded",e),$(this).parent().next().slideToggle(function(){t=0}),$(this).parent().next().attr("aria-hidden",!e),!1}),a.on("keydown",function(t){13===(t.keyCode||e.which)&&$(this).trigger("activate")})}};

var featuredCollectionSection = {
    init: function() {
        $(".js-product-slider .products-slider").each(function(e, t) {
            var a, i, o, n, r, s = $(this).data("products-per-slide"), l = $(this).data("products-limit"), d = $(this).data("products-available");
            a = "2" == s && d > s && l > s || "4" == s && d > s && l > s || "6" == s && d > s && l > s ? "left" : "center",
            d > s && l > s ? (i = !0,
            o = !0,
            n = !0) : (i = !1,
            o = !1,
            n = !1),
            "2" == s && d > s || "4" == s && d > s || "6" == s && d > s ? r = 0 : "3" == s && d ? r = 1 : "5" == s && d ? r = 2 : "7" == s && d && (r = 3),
            $(window).width() <= 798 && (a = "center",
            i = !0,
            o = !0,
            n = !0,
            r = 1,
            $(this).parents(".even-num-slides").removeClass("even-num-slides")),
            $(this).flickity({
                lazyLoad: 2,
                imagesLoaded: !0,
                draggable: i,
                prevNextButtons: o,
                wrapAround: n,
                cellAlign: a,
                pageDots: usePageDots,
                contain: !0,
                freeScroll: !0,
                arrowShape: arrowSize,
                initialIndex: r
            }),
            $(this).addClass("slider-initialized")
        })
    },
    unload: function(e) {
        var t = e.find(".js-product-slider");
        t.hasClass("flickity-enabled") && t.flickity("destroy")
    }
}
  , featuredPromotions = {
    init: function() {
        ($(window).width() > 798 || 0 == $(window).width()) && ($(".feature-overlay").hover(function() {
            $(this).find(".feature-details").slideDown("100", function() {
                $(this).addClass("reveal-details")
            })
        }, function() {
            $(this).find(".feature-details").removeClass("reveal-details"),
            $(this).find(".feature-details").slideUp("100")
        }),
        $(".js-featured-promotions").each(function(e, t) {
            var a = $(this)
              , i = $(this).data("promo-animation");
            a.waypoint(function() {
                $(this.element).find(".feature-section").addClass("animated " + i)
            }, {
                offset: "80%"
            })
        }))
    }
}
  , slideshow = {
    init: function() {
        $(".js-homepage-slideshow").each(function(e, t) {
            var a = $(this)
              , i = {
                slideshowSpeed: 1e3 * a.data("slideshow-speed"),
                slideshowTextAnimation: a.data("slideshow-text-animation"),
                adaptiveHeight: a.data("adaptive-height")
            };
            if (!a.hasClass("flickity-enabled")) {
                var o = 1 !== a.find(".gallery-cell").length;
                if (a.flickity({
                    adaptiveHeight: i.adaptiveHeight,
                    wrapAround: !0,
                    cellAlign: "left",
                    imagesLoaded: !0,
                    prevNextButtons: o,
                    draggable: o,
                    pageDots: usePageDots,
                    autoPlay: i.slideshowSpeed,
                    arrowShape: arrowSize
                }),
                "" != i.slideshowTextAnimation) {
                    var n = a.data("flickity");
                    setTimeout(function() {
                        a.find(".gallery-cell:nth-child(1) .caption-content").addClass("animated " + i.slideshowTextAnimation)
                    }, 400),
                    a.on("select.flickity", function() {
                        if (a.is(":visible")) {
                            var e = n.selectedIndex + 1;
                            setTimeout(function() {
                                a.find(".caption-content").removeClass("animated " + i.slideshowTextAnimation),
                                a.find(".gallery-cell:nth-child(" + e + ") .caption-content").addClass("animated " + i.slideshowTextAnimation)
                            }, 400)
                        }
                    })
                }
            }
            a.find(".gallery-cell").length > 1 ? a.addClass("multi-image") : a.addClass("single-image"),
            a.find(".gallery-cell").each(function() {
                var e = 0;
                $(this).find(".action_button").each(function() {
                    $button = $(this),
                    $(this).width() > e && (e = $(this).width())
                }),
                $(this).find(".action_button").width(e)
            })
        })
    },
    unload: function(e) {
        e.find(".js-homepage-slideshow").flickity("destroy")
    }
}
  , testimonial = {
    init: function() {
        $(".js-testimonial").each(function(e, t) {
            var a = $(this)
              , i = {
                slideshowSpeed: 1e3 * a.data("slideshow-speed"),
                slideshowTextAnimation: a.data("slideshow-text-animation")
            };
            if ($(".testimonial-image").length > 0 && $(".testimonial-block").each(function() {
                if (0 == $(this).find(".testimonial-image").length) {
                    var e = $(this).closest(".testimonial-block");
                    $(e).addClass("set-testimonial-height")
                }
            }),
            !a.hasClass("flickity-enabled")) {
                var o = 1 !== a.find(".gallery-cell").length;
                if (a.flickity({
                    wrapAround: !0,
                    cellAlign: "left",
                    imagesLoaded: !0,
                    prevNextButtons: o,
                    draggable: o,
                    pageDots: usePageDots,
                    autoPlay: i.slideshowSpeed,
                    arrowShape: arrowSize
                }),
                "" != i.slideshowTextAnimation) {
                    var n = a.data("flickity");
                    setTimeout(function() {
                        a.find(".gallery-cell:nth-child(1) .caption-content").addClass("animated " + i.slideshowTextAnimation)
                    }, 400),
                    a.on("select.flickity", function() {
                        if (a.is(":visible")) {
                            var e = n.selectedIndex + 1;
                            setTimeout(function() {
                                a.find(".caption-content").removeClass("animated " + i.slideshowTextAnimation),
                                a.find(".gallery-cell:nth-child(" + e + ") .caption-content").addClass("animated " + i.slideshowTextAnimation)
                            }, 400)
                        }
                    })
                }
            }
            a.find(".gallery-cell").length > 1 ? a.addClass("multi-image") : a.addClass("single-image"),
            a.find(".gallery-cell").each(function() {
                var e = 0;
                $(this).find(".action_button").each(function() {
                    $button = $(this),
                    $(this).width() > e && (e = $(this).width())
                }),
                $(this).find(".action_button").width(e)
            })
        })
    },
    unload: function(e) {
        e.find(".js-testimonial").flickity("destroy")
    }
}
  , gallery = {
    init: function() {
        $(".gallery-horizontal").find(".gallery-image-wrapper").each(function() {
            var e, t, a = $(this), i = $(this).find("img");
            $("<img />").attr("src", $(i).attr("src")).on("load", function() {
                e = this.width,
                t = this.height,
                $(a).css("flex-basis", 200 * e / t),
                $(a).css("flex-grow", 200 * e / t),
                $(a).find("i").css("padding-bottom", t / e * 100 + "%")
            })
        }),
        $("[rel=gallery]").length && $("[rel=gallery]").fancybox({
            baseClass: "gallery-section__lightbox",
            clickContent: "nextOrClose"
        })
    }
}
  , supports_video = function() {
    return !!document.createElement("video").canPlayType
}
  , videoSection = {
    init: function() {
        function e(e) {
            e.find(".caption").not(".display-mobile-text").hide(),
            e.find(".caption").not(".display-mobile-text").find(".action_button").hide()
        }
        ($(".js-video.lazyframe").each(function(e, t) {
            if ($(t).hasClass("showPosterImage--true")) {
                var a = $(t).closest(".video-section").attr("id");
                lazyframe("#" + a + " .lazyframe.showPosterImage--true", {
                    initinview: !1
                })
            } else {
                a = $(t).closest(".video-section").attr("id");
                lazyframe("#" + a + " .lazyframe.showPosterImage--false", {
                    initinview: !0,
                    onLoad: function(e) {
                        $(t).find("iframe").slice(1).remove()
                    }
                })
            }
        }),
        $(".js-video").hasClass("hide-text-on-video") && $(".js-video").hasClass("video-autoplay--true")) && e($(".js-video.hide-text-on-video.video-autoplay--true"));
        $(".video-section .lazyvideo.hide-text-on-video").on("click", function() {
            e($(this).parents(".js-video-section"))
        }),
        $("[data-play-video-button], video.hide-text-on-video").on("click", function() {
            var t = $(this).parents(".js-video-section")
              , a = t.find(".lazyframe")
              , i = t.find(".js-video");
            if (i.data("mp4") || i.data("ogv"))
                t.find(".js-video.hide-text-on-video").length && e(t);
            else {
                var o = document.createElement("iframe");
                iframeSrc = a.data("src"),
                cleanIframeSrc = iframeSrc.substring(0, iframeSrc.indexOf("?")) + "?&autoplay=1",
                o.src = cleanIframeSrc,
                o.setAttribute("allowfullscreen", !0),
                o.setAttribute("frameborder", 0),
                a.append(o),
                t.find(".js-video.hide-text-on-video").length && e(t)
            }
        })
    },
    unload: function(e) {
        e.find("[data-play-video]").off("click"),
        e.find("video.hide-text-on-video").off("click")
    }
}
  , cart = {
    init: function() {
        $("#cart_form .tos_agree").length && $("body").on("click", "#cart_form input[type='submit']", function() {
            if (!$(this).parents("form").find(".tos_agree").is(":checked")) {
                var e = '<p class="warning animated bounceIn">' + Shopify.translation.agree_to_terms_warning + "</p>";
                return 0 == $("p.warning").length && $(this).before(e),
                !1
            }
            $(this).submit()
        })
    }
};
selectCallback = function(e, t) {
    var a = $(".product-" + t.product.id)
      , i = $(".notify-form-" + t.product.id)
      , o = $(".product_form, .shopify-product-form", a)
      , n = o.data("variant-inventory")
      , r = $(".notify_form__inputs")
      , s = Shopify.translation.notify_email
      , l = Shopify.translation.notify_email_send
      , d = r.data("url");
    if (e)
        debugger;
       var WCP_JSON=[];
		  if($('.wcp_json_'+t.product.id).length){    
				WCP_JSON=JSON.parse($('.wcp_json_'+t.product.id)[0].innerText);
			$.each(WCP_JSON.variants, function( index, value ) {
				if(e.id == value.id){
					e.price = value.price;  
					e.compare_at_price = value.compare_at_price;       
				 return false;
				}
			});      
		} 
  
        var c = Shopify.translation.notify_message_first + e.title + Shopify.translation.notify_message_last + d;
    if (r.hasClass("customer--true"))
        var p = '<input type="hidden" class="notify_email" name="contact[email]" id="contact[email]" value="" />';
    else
        p = '<input required type="email" class="notify_email" name="contact[email]" id="contact[email]" placeholder="' + s + '" value="" />';
    var m = p + '<input type="hidden" name="challenge" value="false" /><input type="hidden" name="contact[body]" class="notify_form_message" data-body="' + c + '" value="' + c + '" /><input class="action_button" type="submit" value="' + l + '" style="margin-bottom:0px" />';
    e && e.featured_image && a.is(":visible") && $(".js-product-gallery, .js-gallery-modal", a).each(function() {
        var t = $(this)
          , a = Flickity.data(this);
        if (t.is(":visible") && null != a) {
            var i = $('[data-image-id="' + e.featured_image.id + '"]').data("index");
            a.select(i, !1, !0)
        }
    });
    if (e)
        if (n && n.forEach(function(t) {
            t.id === e.id && (e.inventory_quantity = t.inventory_quantity,
            e.inventory_management = t.inventory_management,
            e.inventory_policy = t.inventory_policy)
        }),
        $(".sku span", a).text(e.sku),
        "swatches" == Shopify.theme_settings.product_form_style)
            for (var f = 0, u = e.options.length; f < u; f++) {
                var y = o.find('.swatch[data-option-index="' + escape(f) + '"] :radio[value="' + e.options[f].replace(/\"/g, '\\"') + '"]');
                y.length && (y.get(0).checked = !0)
            }
        else
            $(".notify_form_message", a).attr("value", $(".notify_form_message", a).data("body") + " - " + e.title);
    if (e && 1 == e.available) {
        if (e.price < e.compare_at_price ? ($(".was_price", a).html('<span class="money">' + Shopify.formatMoney(e.compare_at_price, $("body").data("money-format")) + "</span>"),
        $(".savings", a).html(Shopify.translation.savings_text + " " + parseInt(100 * (e.compare_at_price - e.price) / e.compare_at_price) + '% (<span class="money">' + Shopify.formatMoney(e.compare_at_price - e.price, $("body").data("money-format")) + "</span>)"),
        $(".current_price", a).parent().addClass("sale")) : ($(".was_price", a).html(""),
        $(".savings", a).html(""),
        $(".current_price", a).parent().removeClass("sale")),
        e.inventory_management && e.inventory_quantity > 0) {
            if (Shopify.theme_settings.display_inventory_left) {
                1 == e.inventory_quantity ? items_left_text = Shopify.translation.one_item_left : items_left_text = Shopify.translation.items_left_text;
                var h = parseInt(Shopify.theme_settings.inventory_threshold);
                e.inventory_quantity <= h ? $(".items_left", a).html(e.inventory_quantity + " " + items_left_text) : $(".items_left", a).html("")
            }
            Shopify.theme_settings.limit_quantity && "deny" == e.inventory_policy && $(".quantity", a).attr("max", e.inventory_quantity)
        } else
            $(".items_left", a).text(""),
            $(".quantity", a).removeAttr("max");
        $(".sold_out", a).text(""),
        e.price > 0 ? $(".current_price", a).removeClass("sold_out").html('<span class="money">' + Shopify.formatMoney(e.price, $("body").data("money-format")) + "</span>") : $(".current_price", a).removeClass("sold_out").html(Shopify.theme_settings.free_text),
        $(".add_to_cart", a).removeClass("disabled").removeAttr("disabled").find("span").text($(".add_to_cart", a).data("label")),
        $(".shopify-payment-button", a).removeClass("disabled"),
        $(".purchase-details__buttons", a).removeClass("product-is-unavailable"),
        $(".modal_price", a).removeClass("variant-unavailable"),
        i.hide(),
        r.empty()
    } else {
        var g = e ? Shopify.theme_settings.sold_out_text : Shopify.translation.unavailable_text;
        e ? (e.price > 0 ? $(".current_price", a).html('<span class="money">' + Shopify.formatMoney(e.price, $("body").data("money-format")) + "</span>") : $(".current_price", a).html(Shopify.theme_settings.free_text),
        Shopify.theme_settings.display_sold_out_price && $(".current_price", a).parents(".price__container--display-price-true").addClass("has-margin-right"),
        $(".modal_price", a).removeClass("variant-unavailable")) : ($(".modal_price", a).addClass("variant-unavailable"),
        $(".current_price", a).html(""),
        $(".was_price", a).html(""),
        $(".savings", a).html(""),
        $(".current_price", a).parents(".price__container--display-price-true").removeClass("has-margin-right")),
        Shopify.theme_settings.display_sold_out_price || ($(".current_price", a).html(""),
        $(".was_price", a).html(""),
        $(".savings", a).html("")),
        $(".items_left", a).text(""),
        $(".quantity", a).removeAttr("max"),
        $(".sold_out", a).text(g),
        $(".purchase-details__buttons", a).addClass("product-is-unavailable"),
        $(".add_to_cart", a).addClass("disabled").attr("disabled", "disabled").find("span").text(g),
        $(".shopify-payment-button").addClass("disabled"),
        i.hide(),
        r.empty(),
        e && !e.available && (i.fadeIn(),
        r.empty(),
        r.append(m))
    }
    Shopify.theme_settings.show_multiple_currencies && convertCurrencies()
}
;
var productPage = {
    init: function() {
        var e = !0
          , t = !0
          , a = $(".js-product-gallery").data("autoplay");
        setTimeout(function() {
            imageFunctions.linkGalleryAndCarousel($(".js-product-page-gallery .js-product-gallery"), $(".js-product-page-gallery .product_gallery_nav"))
        }, 1e3),
        $(".js-full-width-product-images").length && imageFunctions.fullWidth(".product-template .product .description img", ".js-full-width-product-images"),
        $(".js-product-gallery").hasClass("single-image") && (e = !1,
        t = !1),
        $(".product_section .description").find("iframe").wrap('<div class="lazyframe" data-ratio="16:9"></div>'),
        is_touch_device() && $(".js-product-gallery").hasClass("popup-enabled--false") ? (imageFunctions.zoom(".js-product-gallery"),
        e = !1) : imageFunctions.zoom(".js-product-gallery", !1),
        $(".js-product-gallery").flickity({
            adaptiveHeight: !0,
            wrapAround: "true",
            cellAlign: "left",
            draggable: e,
            contain: !0,
            imagesLoaded: !0,
            lazyLoad: 2,
            pageDots: !1,
            prevNextButtons: t,
            autoPlay: !!a && 6e3,
            dragThreshold: 10,
            arrowShape: arrowSize
        });
        var i = !0
          , o = !1
          , n = !1;
        $(".product_gallery_nav .gallery-cell").length >= 7 && (i = !1,
        o = !0,
        "left",
        n = !0),
        $(".product-template .product_gallery_nav.product_gallery_nav--bottom-slider").flickity({
            asNavFor: ".product_gallery",
            adaptiveHeight: !1,
            wrapAround: n,
            cellAlign: "center",
            draggable: !0,
            groupCells: i,
            prevNextButtons: o,
            pageDots: !1,
            lazyLoad: 2,
            dragThreshold: 10,
            arrowShape: arrowSize
        }),
        "?contact_posted=true" === window.location.search && ($(".notify_form .contact-form").hide(),
        $(".notify_form .contact-form").prev(".message").html(Shopify.translation.notify_success_text)),
        $(".notify_form .contact-form").each(function() {
            var e = $(this);
            e.on("submit", function(t) {
                "true" !== $('input[name="challenge"]', e).val() && ($.ajax({
                    type: e.attr("method"),
                    url: e.attr("action"),
                    data: e.serialize(),
                    success: function(t) {
                        e.fadeOut("slow", function() {
                            e.prev(".message").html(Shopify.translation.notify_success_text)
                        })
                    },
                    error: function(t) {
                        $('input[name="challenge"]', e).val("true"),
                        e.submit()
                    }
                }),
                t.preventDefault())
            })
        }),
        "swatches" == Shopify.theme_settings.product_form_style && $("body").on("change", ".swatch :radio", function() {
            var e = $(this).closest(".swatch").attr("data-option-index")
              , t = $(this).val()
              , a = $(this).closest(".product_form form");
            if (a.siblings(".notify_form").length)
                var i = a.siblings(".notify_form");
            else
                i = $(".js-notify-form");
            var o = a.find(".swatch_options input:checked").eq(0).val()
              , n = a.find(".swatch_options input:checked").eq(1).val() || ""
              , r = a.find(".swatch_options input:checked").eq(2).val() || "";
            if (o && n && r)
                var s = o + " / " + n + " / " + r;
            else if (o && n)
                s = o + " / " + n;
            else
                s = o;
            i.find(".notify_form_message").attr("value", i.find(".notify_form_message").data("body") + " - " + s),
            $(this).closest("form").find(".single-option-selector").eq(e).val(t).trigger("change")
        }),
        $(".js-product-gallery a").fancybox({
            baseClass: "product-section__lightbox",
            clickContent: !1,
            afterShow: function(e, t) {
                e.$trigger.first().parents(".js-product-gallery").data("zoom") && $(".fancybox-image").wrap('<span class="zoom-wrap" style="display:inline-block"></span>').css("display", "block").parent().zoom({
                    touch: !1,
                    magnify: 1
                })
            },
            afterClose: function(e, t) {
                const a = e.$trigger.first().parents(".js-product-gallery");
                a.hide(),
                setTimeout(function() {
                    a.fadeIn(100)
                }, 1)
            }
        }),
        $(".js-product_section .product_form_options").each(function() {
            $(this).find(".selector-wrapper select").length != $(this).data("options-size") && new Shopify.OptionSelectors($(this).data("select-id"),{
                product: $(this).data("product"),
                onVariantSelected: selectCallback,
                enableHistoryState: $(this).data("enable-state")
            })
        }),
        $(".product-recommendations-container").length && productPage.loadProductRecommendations()
    },
    loadProductRecommendations: function() {
        var e = $(".meta-related-recommended-collection")
          , t = $(".product-recommendations")
          , a = t.data("productId")
          , i = t.data("limit")
          , o = t.data("enabled")
          , n = e.data("enabled")
          , r = $("[data-product-recommendations-container]")
          , s = $(".js-recommended-products-slider");
        if (e.length) {
            if (!n)
                return void r.empty();
            r.html(e.html()),
            s.length && this.recommendedProductsSlider(),
            $("[data-product-recommendations-container] .js-product_section .product_form_options").each(function() {
                0 === $(this).find("select").length && new Shopify.OptionSelectors($(this).data("select-id"),{
                    product: $(this).data("product"),
                    onVariantSelected: selectCallback,
                    enableHistoryState: $(this).data("enable-state")
                })
            }),
            Shopify.PaymentButton && Shopify.PaymentButton.init(),
            $(".recommended-products-section").empty()
        } else if (t.length) {
            if (!o)
                return void r.empty();
            $.ajax({
                type: "GET",
                url: "/recommendations/products?section_id=product-recommendations&limit=" + i + "&product_id=" + a,
                success: function(e) {
                    var t = $(e).find(".product-recommendations").html();
                    r.empty(),
                    r.html(t),
                    s.length && productPage.recommendedProductsSlider(),
                    $("[data-product-recommendations-container] .js-product_section .product_form_options").each(function() {
                        new Shopify.OptionSelectors($(this).data("select-id"),{
                            product: $(this).data("product"),
                            onVariantSelected: selectCallback,
                            enableHistoryState: $(this).data("enable-state")
                        })
                    }),
                    Shopify.PaymentButton && Shopify.PaymentButton.init(),
                    0 === $("[data-recommended-product-count]").data() && $("[data-product-recommendations-container]").hide()
                }
            })
        } else
            r.hide()
    },
    productSwatches: function() {
        if ("swatches" == Shopify.theme_settings.product_form_style) {
            if ($(".js-product_section").length) {
                var e = $(".js-product_section").find(".product_form");
                e.addClass("is-visible"),
                e.each(function() {
                    var e = $(this).data("product")
                      , t = ".product-" + $(this).data("product-id") + " .js-product_section";
                    $(this).find(".swatch_options .swatch").length > 1 && Shopify.linkOptionSelectors(e, t)
                })
            }
            $(".js-product_section").length > 1 && $("body").on("click", ".swatch-element", function() {
                var e = $(this).data("value").toString();
                $(this).siblings('input[value="' + e.replace(/\"/g, '\\"') + '"]').prop("checked", !0).trigger("change");
                var t = $(this).parents(".product_form").data("product")
                  , a = ".product-" + $(this).parents(".product_form").data("product-id") + " .js-product_section";
                $(this).parents(".product_form").find(".swatch_options .swatch").length > 1 && Shopify.linkOptionSelectors(t, a)
            })
        }
    },
    recommendedProductsSlider: function() {
        $(".js-recommended-products-slider .products-slider").each(function(e, t) {
            var a, i, o, n, r, s = $(this).data("products-per-slide"), l = $(this).data("products-limit"), d = $(this).data("products-available");
            a = "2" == s && d > s && l > s || "4" == s && d > s && l > s || "6" == s && d > s && l > s ? "left" : "center",
            d > s && l > s ? (i = !0,
            o = !0,
            n = !0) : (i = !1,
            o = !1,
            n = !1),
            "2" == s && d > s || "4" == s && d > s || "6" == s && d > s ? r = 0 : "3" == s && d ? r = 1 : "5" == s && d ? r = 2 : "7" == s && d && (r = 3),
            $(window).width() <= 798 && (a = "center",
            i = !0,
            o = !0,
            n = !0,
            r = 1,
            $(this).parents(".even-num-slides").removeClass("even-num-slides")),
            $(this).flickity({
                lazyLoad: 2,
                imagesLoaded: !0,
                draggable: i,
                cellAlign: a,
                prevNextButtons: o,
                wrapAround: n,
                pageDots: usePageDots,
                contain: !0,
                freeScroll: !0,
                arrowShape: arrowSize,
                initialIndex: r
            })
        })
    },
    initializeQuantityBox: function() {
        $("body").on("click", ".js-change-quantity", function() {
            var e = $(this)
              , t = $(this).siblings("input")
              , a = parseInt(t.val())
              , i = 1e29
              , o = t.attr("min") || 0;
            return null != t.attr("max") && (i = t.attr("max")),
            isNaN(a) || a < o ? (t.val(o),
            !1) : a > i ? (t.val(i),
            !1) : ("plus" == e.data("func") ? a < i && t.val(a + 1) : (a > o && t.val(a - 1),
            e.parents(".cart_item").length && a - 1 == 0 && e.closest(".cart_item").addClass("animated fadeOutUp")),
            void t.trigger("change"))
        })
    },
    unload: function(e) {
        e.find(".products-slider").flickity("destroy"),
        $("body").off("click", ".js-change-quantity")
    }
}
  , header = {
    init: function() {
        var e = function() {
            $("body").removeClass("is-active").removeClass("blocked-scroll"),
            $(".dropdown_link").toggleClass("active_link"),
            $(".cart_container").removeClass("active_link")
        };
        ($(".dropdown_link--vertical").length && ($(".dropdown_link--vertical, .vertical-menu_submenu").on("mouseover", function(e) {
            $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]'),
            $(this).attr("data-click-count");
            $(".active_link").removeClass("active_link"),
            $(this).hasClass("active_link") || ($(this).children("a").addClass("active_link"),
            $(".is-absolute").parent().removeClass("feature_image"))
        }),
        is_touch_device() && $(".vertical-menu .sublink a, .vertical-menu_submenu .sublink a").on("touchstart click", function(e) {
            e.stopPropagation();
            var t = $(this);
            function a(t) {
                var a = $(t).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')
                  , i = $(t).next(".vertical-menu_submenu")
                  , o = $(t).attr("data-click-count");
                if ($(".dropdown_link--vertical").not(t).attr("data-click-count", 0),
                $(".dropdown_link--vertical").attr("data-no-instant", !0),
                $(".dropdown_container").hide(),
                a.show(),
                $(".vertical-menu_submenu").removeClass("is-visible"),
                i.addClass("is-visible"),
                "touchstart" == e.type && (o++,
                $(t).attr("data-click-count", o),
                o < 2))
                    return e.preventDefault(),
                    e.stopPropagation(),
                    !1
            }
            "touchstart" == e.type ? (clicked = !0,
            $(this).attr("data-click-count") < 1 && (a(t),
            e.preventDefault())) : "click" != e.type || clicked ? clicked = !1 : $(this).attr("data-click-count") < 1 && (a(t),
            e.preventDefault())
        })),
        $(".promo_banner").length) && ("dismiss" != Cookies.get("promo_banner") && ($("body").addClass("promo_banner-show"),
        $(".promo_banner").on("click", ".promo_banner-close", function() {
            $("body").removeClass("promo_banner-show"),
            Cookies.set("promo_banner", "dismiss", {
                expires: 30
            })
        })));
        if ($(".vertical-menu_submenu, .vertical-menu_sub-submenu").each(function() {
            $(this).is(":off-right") && $(this).addClass("vertical-menu--align-right")
        }),
        $("html").on("click", function(t) {
            !$(t.target).closest(".cart_container").length && $(".cart_content").is(":visible") && e(),
            !$(t.target).closest(".dropdown_container").length && $(".dropdown").is(":visible") && ($("body").removeClass("is-active"),
            $(".dropdown_link").removeClass("active_link"),
            $(".dropdown_container").hide(),
            $(".mobile_nav").find("div").removeClass("open"))
        }),
        $(window).width() > 798) {
            if ($(".header").hasClass("header-fixed--true")) {
                if ($("body").on("click", '.banner a[href^="#"]', function(e) {
                    e.preventDefault();
                    var t = $(this).attr("href")
                      , a = $(".main_nav_wrapper.sticky_nav").outerHeight();
                    $("html, body").animate({
                        scrollTop: $(t).offset().top - a
                    }, 2e3)
                }),
                !$(".main_nav_wrapper").hasClass("sticky_nav"))
                    new Headhesive(".main_nav_wrapper",{
                        offset: 700,
                        throttle: 300,
                        classes: {
                            clone: "sticky_nav",
                            stick: "sticky_nav--stick",
                            unstick: "sticky_nav--unstick"
                        },
                        onInit: function() {
                            if ($(".sticky_nav .secondary_logo").css("display", "none"),
                            $(".sticky_nav .primary_logo").css("display", "block"),
                            $(".sticky_nav .icon-search").css("display", "block"),
                            $(".sticky_nav .search_container").css("display", "none"),
                            $(".sticky_nav .nav:last").prepend($(".header .cart_container").clone()),
                            "inline" == Shopify.theme_settings.menu_position)
                                $(".sticky_nav").height();
                            else
                                $(".sticky_nav .nav").height()
                        },
                        onStick: function() {
                            $(".sticky_nav .mini_cart").css("height", $(".sticky_nav .main_nav").height()),
                            $(".sticky_nav .cart_content").css("top", $(".sticky_nav .main_nav").height())
                        },
                        onUnstick: function() {
                            $(".cart_container").removeClass("active_link")
                        }
                    })
            } else
                $(".header-fixed--true").removeClass("header-fixed--true"),
                $(".main_nav_wrapper").length > 1 && $(".main_nav_wrapper").first().remove();
            $("img.primary_logo:visible") ? $(".logo img", $(".feature_image .header")).attr("src", $(".logo img").data("src-home")) : $(".logo img").attr("src", $(".logo img").data("src"))
        } else
            $("#header").hasClass("mobile_nav-fixed--true") ? ($("body").addClass("mobile_nav-fixed--true"),
            $("body").on("click", '.banner a[href^="#"]', function(e) {
                e.preventDefault();
                var t = $(this).attr("href")
                  , a = $("#header").outerHeight();
                $("html, body").animate({
                    scrollTop: $(t).offset().top - a
                }, 2e3)
            })) : $("body").addClass("mobile_nav-fixed--false");
        $("#header .cart_content").length < 1 && $("#header .cart_container").append($(".header .cart_content").clone()),
        is_touch_device() && $(window).width() <= 798 || $(window).width() <= 798 ? ($(".dropdown_link").attr("data-no-instant", !0),
        $("body").on("click", ".dropdown_link", function(e) {
            if ($(".nav a").removeClass("active_link"),
            $("#header").is(":visible")) {
                var t = $(this).parents("#header").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]');
                $(this).hasClass("mini_cart") || $(".cart_container").removeClass("active_link")
            } else {
                if ($(this).hasClass("icon-search"))
                    return window.location = $(this).attr("href"),
                    !1;
                t = $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')
            }
            if (t.is(":visible") || void 0 === t.attr("class") ? (t.hide(),
            $("body").removeClass("is-active")) : ($(".dropdown_container").hide(),
            $(this).hasClass("cart_container") || $(".is-absolute").parent().removeClass("feature_image"),
            t.show(),
            $("body").addClass("is-active"),
            $(".mobile_nav").find("div").removeClass("open")),
            t.is(":visible"))
                return e.stopPropagation(),
                !1
        }),
        $("body").on("click", ".mobile_nav", function() {
            $(this).find("div").toggleClass("open")
        }),
        "redirect_cart" != Shopify.theme_settings.cart_action && $(".mini_cart").on("click", function(t) {
            var a = $(this).parent();
            a.hasClass("active_link") ? (e(),
            $("body").removeClass("blocked-scroll")) : (!function(e) {
                $("body").addClass("blocked-scroll"),
                $(".mobile_nav div").removeClass("open"),
                $(".dropdown_link").removeClass("active_link"),
                e.addClass("active_link")
            }(a),
            $("body").addClass("blocked-scroll")),
            touch_device && t.preventDefault()
        }),
        $(".cart_content__continue-shopping").on("click", function(t) {
            e()
        })) : ($(".nav a, .logo a").not(".cart_content a").on("mouseenter", function() {
            $(this).hasClass("active_link") || 0 != $(".dropdown_link--vertical").length || ($(".dropdown_container").hide(),
            $(".active_link").removeClass("active_link"),
            $(".is-absolute").parent().addClass("feature_image"))
        }),
        $(".main_nav, .top_bar, .cart_container").on("mouseleave", function() {
            $(window).width() > 798 && $(".dropdown_container").hide(),
            $(".active_link").removeClass("active_link"),
            $(".is-absolute").parent().addClass("feature_image")
        }),
        $(".dropdown_link, .dropdown_link--vertical").attr("data-click-count", 0),
        $(".dropdown_link").on("mouseover touchstart", function(e) {
            $(window).width() > 798 && $(".dropdown_container").hide();
            var t = $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]')
              , a = $(this).attr("data-click-count");
            if ($(".active_link").removeClass("active_link"),
            $(this).hasClass("active_link") || (t.show(),
            $(this).hasClass("mini_cart") ? $(this).parent(".cart_container").addClass("active_link") : ($(window).width() > 798 && $(this).addClass("active_link"),
            $(".is-absolute").parent().removeClass("feature_image"))),
            is_touch_device() && ($(".dropdown_link").not(this).attr("data-click-count", 0),
            $(".dropdown_link").attr("data-no-instant", !0),
            "touchstart" == e.type && (a++,
            $(this).attr("data-click-count", a),
            a < 2)))
                return e.preventDefault(),
                e.stopPropagation(),
                !1
        }))
    },
    removeDataAttributes: function(e) {
        if ($(e).length) {
            var t, a = $(e), i = [], o = a.get(0).attributes, n = o.length;
            for (t = 0; t < n; t++)
                "data-" === o[t].name.substring(0, 5) && i.push(o[t].name);
            $.each(i, function(e, t) {
                a.removeAttr(t)
            })
        }
    },
    loadMegaMenu: function() {
        $(".sticky_nav .mega-menu").remove(),
        $(".header .mega-menu").remove(),
        $(".mega-menu-container .mega-menu").clone().appendTo(".sticky_nav .main_nav"),
        header.removeDataAttributes(".sticky_nav .mega-menu.dropdown_container .dropdown_column"),
        $(".mega-menu-container .mega-menu").each(function(e) {
            var t = $(this).data("dropdown");
            $('[data-dropdown-rel="' + t + '"]').find("span").remove(),
            $('[data-dropdown-rel="' + t + '"]').not(".icon-search").append(' <span class="icon-down-arrow"></span>').addClass("mega-menu-parent").addClass("dropdown_link").removeClass("top_link"),
            $('[data-dropdown="' + t + '"]').each(function(e) {
                $(this).hasClass("mega-menu") || $(this).remove()
            }),
            $(this).clone().appendTo(".header .main_nav")
        }),
        $(".dropdown_link--vertical").length && ($(".dropdown_link--vertical.mega-menu-parent + .vertical-menu_submenu").remove(),
        $(".dropdown_link--vertical:not(.mega-menu-parent)").each(function(e) {
            var t = $(this).data("dropdown-rel");
            $('[data-dropdown="' + t + '"]').remove()
        })),
        $(".mega-menu-parent").on("mouseenter", function() {
            $(this).hasClass("active_link") || ($(".dropdown_container").hide(),
            $(this).parents(".main_nav").find('[data-dropdown="' + $(this).data("dropdown-rel") + '"]').toggle(),
            $(this).addClass("active_link"),
            $(".is-absolute").parent().removeClass("feature_image"))
        }),
        header.removeDataAttributes(".header .mega-menu.dropdown_container .dropdown_column"),
        (is_touch_device() || $(window).width() <= 798) && $(".dropdown_link").attr("data-no-instant", !0),
        header.loadMobileMegaMenu()
    },
    loadMobileMegaMenu: function() {
        $(".mega-menu-container .mobile-mega-menu").each(function(e) {
            $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').find("span").remove(),
            $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > a').append(' <span class="right icon-down-arrow"></span>').attr("data-no-instant", "true"),
            $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').addClass("mobile-mega-menu-parent sublink"),
            $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"]').append(this),
            $('[data-mobile-dropdown-rel="' + $(this).data("mobile-dropdown") + '"] > ul').each(function(e) {
                $(this).hasClass("mobile-mega-menu") || $(this).remove()
            })
        })
    },
    unloadMegaMenu: function() {
        $(".header .mega-menu").remove(),
        $(".mega-menu-container .mega-menu").each(function(e) {
            $(this).data("dropdown");
            $('.mega-menu-parent[data-dropdown-rel="' + $(this).data("dropdown") + '"]').find(".icon-down-arrow").remove()
        })
    },
    unload: function() {
        $("body").off("click", ".mobile_nav"),
        $("body").off("click", ".dropdown_link"),
        $("html").off("click"),
        $(".mini_cart").off("click"),
        $(".cart_content__continue-shopping").off("click"),
        $("body").off("click", '.banner a[href^="#"]'),
        $(".main_nav_wrapper.sticky_nav").remove()
    }
}
  , social = {
    twitter: function() {
        $(".twitter-timeline").length && (window.twttr ? window.twttr.ready(function(e) {
            e.widgets.load(document.getElementById("twitter-timeline"))
        }) : window.twttr = function(e, t, a) {
            var i, o, n = e.getElementsByTagName(t)[0];
            if (!e.getElementById(a))
                return (o = e.createElement(t)).id = a,
                o.src = "https://platform.twitter.com/widgets.js",
                n.parentNode.insertBefore(o, n),
                window.twttr || (i = {
                    _e: [],
                    ready: function(e) {
                        i._e.push(e)
                    }
                })
        }(document, "script", "twitter-wjs"))
    },
    unload: function() {}
}
  , instagram = {
    loadContent: function(e) {
        if (e.clientID) {
            var t = "https://api.instagram.com/v1/users/self/media/recent/?access_token=" + e.clientID;
            $.ajax({
                type: "GET",
                url: t,
                dataType: "jsonp",
                success: function(t) {
                    if (200 === t.meta.code && t.data.length) {
                        t = t.data;
                        var a = 0;
                        e.el.empty();
                        for (var i = 0; i < t.length; i++) {
                            var o, n = t[i], r = n.images.low_resolution.url;
                            if (!n.images.low_resolution.url.indexOf("null") > -1 && (o = '<div class="il-photo__img instagram__bg" style="background-image:url(' + r + ')" data-filter="' + n.filter + '" /></div>',
                            o = '<a href="' + n.link + '" target="_blank" class="instagram__link">' + o + "</a>"),
                            n.videos && (o = '<div class="instagram__video instagram__bg" style="background-image:url(' + r + ')" data-filter="' + n.filter + '" /></div>',
                            o = '<a href="' + n.link + '" target="_blank" class="instagram__link instagram__video-link">' + o + "</a>"),
                            o && (o = '<div class="' + e.column + ' columns instagram__item small-down--one-whole">' + o + "</div>"),
                            "" !== o && (e.el.append(o),
                            a++),
                            a == e.limit)
                                break
                        }
                    }
                },
                error: function() {}
            })
        }
    }
};
$(".social-feeds-wrap").each(function(e, t) {
    social.twitter();
    var a = $(this).find(".js-instafeed");
    instagram.loadContent({
        el: a,
        clientID: a.data("client-id"),
        limit: a.data("count"),
        column: a.data("column")
    })
});
var mapFunction = {
    init: function() {
        if ($(".lazymap").length > 0 && lazyframe(".lazymap"),
        $(".maps").hasClass("js-api-map")) {
            var e = [];
            $(".map").each(function(t, a) {
                e.push(this),
                e[t].sectionid = $(this).data("id"),
                e[t].address = $(this).data("address"),
                e[t].directions = $(this).data("directions-address"),
                e[t].zoom = $(this).data("zoom"),
                e[t].mapstyle = $(this).data("style"),
                e[t].showpin = $(this).data("pin"),
                e[t].apikey = $(this).data("api-key")
            }),
            $.each(e, function(t, a) {
                $.ajaxSetup({
                    cache: !0
                }),
                $.getScript("https://maps.googleapis.com/maps/api/js?key=" + e[t].apikey).then(function() {
                    mapFunction.findLocation(e[t]),
                    $.ajaxSetup({
                        cache: !1
                    })
                })
            })
        }
    },
    findLocation: function(e) {
        var t, a;
        (new google.maps.Geocoder).geocode({
            address: e.address
        }, function(i, o) {
            o == google.maps.GeocoderStatus.OK ? (t = i[0].geometry.location.lat(),
            a = i[0].geometry.location.lng(),
            mapFunction.initMap(t, a, e)) : console.log("Error:" + o)
        })
    },
    initMap: function(e, t, a) {
        var i = {
            lat: e,
            lng: t
        }
          , o = [];
        o = "aubergine" == a.mapstyle ? [{
            elementType: "geometry",
            stylers: [{
                color: "#1d2c4d"
            }]
        }, {
            elementType: "labels.text.fill",
            stylers: [{
                color: "#8ec3b9"
            }]
        }, {
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#1a3646"
            }]
        }, {
            featureType: "administrative.country",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#4b6878"
            }]
        }, {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#64779e"
            }]
        }, {
            featureType: "administrative.province",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#4b6878"
            }]
        }, {
            featureType: "landscape.man_made",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#334e87"
            }]
        }, {
            featureType: "landscape.natural",
            elementType: "geometry",
            stylers: [{
                color: "#023e58"
            }]
        }, {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{
                color: "#283d6a"
            }]
        }, {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#6f9ba5"
            }]
        }, {
            featureType: "poi",
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#1d2c4d"
            }]
        }, {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{
                color: "#023e58"
            }]
        }, {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#3C7680"
            }]
        }, {
            featureType: "road",
            elementType: "geometry",
            stylers: [{
                color: "#304a7d"
            }]
        }, {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#98a5be"
            }]
        }, {
            featureType: "road",
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#1d2c4d"
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{
                color: "#2c6675"
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#255763"
            }]
        }, {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#b0d5ce"
            }]
        }, {
            featureType: "road.highway",
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#023e58"
            }]
        }, {
            featureType: "transit",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#98a5be"
            }]
        }, {
            featureType: "transit",
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#1d2c4d"
            }]
        }, {
            featureType: "transit.line",
            elementType: "geometry.fill",
            stylers: [{
                color: "#283d6a"
            }]
        }, {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{
                color: "#3a4762"
            }]
        }, {
            featureType: "water",
            elementType: "geometry",
            stylers: [{
                color: "#0e1626"
            }]
        }, {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#4e6d70"
            }]
        }] : "retro" == a.mapstyle ? [{
            elementType: "geometry",
            stylers: [{
                color: "#ebe3cd"
            }]
        }, {
            elementType: "labels.text.fill",
            stylers: [{
                color: "#523735"
            }]
        }, {
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#f5f1e6"
            }]
        }, {
            featureType: "administrative",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#c9b2a6"
            }]
        }, {
            featureType: "administrative.land_parcel",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#dcd2be"
            }]
        }, {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#ae9e90"
            }]
        }, {
            featureType: "landscape.natural",
            elementType: "geometry",
            stylers: [{
                color: "#dfd2ae"
            }]
        }, {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{
                color: "#dfd2ae"
            }]
        }, {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#93817c"
            }]
        }, {
            featureType: "poi.park",
            elementType: "geometry.fill",
            stylers: [{
                color: "#a5b076"
            }]
        }, {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#447530"
            }]
        }, {
            featureType: "road",
            elementType: "geometry",
            stylers: [{
                color: "#f5f1e6"
            }]
        }, {
            featureType: "road.arterial",
            elementType: "geometry",
            stylers: [{
                color: "#fdfcf8"
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{
                color: "#f8c967"
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#e9bc62"
            }]
        }, {
            featureType: "road.highway.controlled_access",
            elementType: "geometry",
            stylers: [{
                color: "#e98d58"
            }]
        }, {
            featureType: "road.highway.controlled_access",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#db8555"
            }]
        }, {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#806b63"
            }]
        }, {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [{
                color: "#dfd2ae"
            }]
        }, {
            featureType: "transit.line",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#8f7d77"
            }]
        }, {
            featureType: "transit.line",
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#ebe3cd"
            }]
        }, {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{
                color: "#dfd2ae"
            }]
        }, {
            featureType: "water",
            elementType: "geometry.fill",
            stylers: [{
                color: "#b9d3c2"
            }]
        }, {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#92998d"
            }]
        }] : "silver" == a.mapstyle ? [{
            elementType: "geometry",
            stylers: [{
                color: "#f5f5f5"
            }]
        }, {
            elementType: "labels.icon",
            stylers: [{
                visibility: "off"
            }]
        }, {
            elementType: "labels.text.fill",
            stylers: [{
                color: "#616161"
            }]
        }, {
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#f5f5f5"
            }]
        }, {
            featureType: "administrative.land_parcel",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#bdbdbd"
            }]
        }, {
            featureType: "poi",
            elementType: "geometry",
            stylers: [{
                color: "#eeeeee"
            }]
        }, {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#757575"
            }]
        }, {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{
                color: "#e5e5e5"
            }]
        }, {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#9e9e9e"
            }]
        }, {
            featureType: "road",
            elementType: "geometry",
            stylers: [{
                color: "#ffffff"
            }]
        }, {
            featureType: "road.arterial",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#757575"
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{
                color: "#dadada"
            }]
        }, {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#616161"
            }]
        }, {
            featureType: "road.local",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#9e9e9e"
            }]
        }, {
            featureType: "transit.line",
            elementType: "geometry",
            stylers: [{
                color: "#e5e5e5"
            }]
        }, {
            featureType: "transit.station",
            elementType: "geometry",
            stylers: [{
                color: "#eeeeee"
            }]
        }, {
            featureType: "water",
            elementType: "geometry",
            stylers: [{
                color: "#c9c9c9"
            }]
        }, {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#9e9e9e"
            }]
        }] : "night" == a.mapstyle ? [{
            elementType: "geometry",
            stylers: [{
                color: "#242f3e"
            }]
        }, {
            elementType: "labels.text.fill",
            stylers: [{
                color: "#746855"
            }]
        }, {
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#242f3e"
            }]
        }, {
            featureType: "administrative.locality",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#d59563"
            }]
        }, {
            featureType: "poi",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#d59563"
            }]
        }, {
            featureType: "poi.park",
            elementType: "geometry",
            stylers: [{
                color: "#263c3f"
            }]
        }, {
            featureType: "poi.park",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#6b9a76"
            }]
        }, {
            featureType: "road",
            elementType: "geometry",
            stylers: [{
                color: "#38414e"
            }]
        }, {
            featureType: "road",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#212a37"
            }]
        }, {
            featureType: "road",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#9ca5b3"
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry",
            stylers: [{
                color: "#746855"
            }]
        }, {
            featureType: "road.highway",
            elementType: "geometry.stroke",
            stylers: [{
                color: "#1f2835"
            }]
        }, {
            featureType: "road.highway",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#f3d19c"
            }]
        }, {
            featureType: "transit",
            elementType: "geometry",
            stylers: [{
                color: "#2f3948"
            }]
        }, {
            featureType: "transit.station",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#d59563"
            }]
        }, {
            featureType: "water",
            elementType: "geometry",
            stylers: [{
                color: "#17263c"
            }]
        }, {
            featureType: "water",
            elementType: "labels.text.fill",
            stylers: [{
                color: "#515c6d"
            }]
        }, {
            featureType: "water",
            elementType: "labels.text.stroke",
            stylers: [{
                color: "#17263c"
            }]
        }] : [],
        $(".js-map-link").attr("href", "https://www.google.com/maps/place/" + a.directions + "/@" + e + "," + t);
        var n = {
            zoom: a.zoom,
            center: i,
            styles: o,
            disableDefaultUI: !1
        }
          , r = new google.maps.Map(document.getElementById(a.sectionid),n);
        if (1 == a.showpin)
            new google.maps.Marker({
                position: i,
                map: r
            })
    }
}
  , faqAccordion = {
    init: function() {
        var t = 0
          , a = $(".faqAccordion > dt > button");
        $(".faqAccordion > dd").attr("aria-hidden", !0),
        a.attr("aria-expanded", !1),
        a.on("click activate", function() {
            if (t)
                return !1;
            t = 1;
            var e = "false" === $(this).attr("aria-expanded");
            return $(this).attr("aria-expanded", e),
            $(this).parent().next().slideToggle(function() {
                t = 0
            }),
            $(this).parent().next().attr("aria-hidden", !e),
            !1
        }),
        a.on("keydown", function(t) {
            13 === (t.keyCode || e.which) && $(this).trigger("activate")
        })
    }
};
